<router-outlet></router-outlet>
<block-ui></block-ui>
<ng-container *ngIf="isFullyBrowser">
  <app-iframe-overlay-container></app-iframe-overlay-container>
</ng-container>
